import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { Response } from '@shared/interfaces/response/response';
import { MovimientoCaja } from '@p-p-portafolio/interfaces/movimientoCaja';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({ providedIn: 'root' })
export class MovimientoCajaService {
  private _url = environment.apiBaseUrl + 'api/parimetria/portafolio/movimientoscaja/';

  constructor(private _http: HttpClient) {}

  create(model: MovimientoCaja): Observable<Response> {
    return this._http.post<Response>(this._url, model, httpOption);
  }

  read(): Observable<Response> {
    return this._http.get<Response>(this._url);
  }

  readTipoTrans(): Observable<Response> {
    return this._http.get<Response>(this._url + 'tipoTrans/');
  }

  update(model: MovimientoCaja): Observable<Response> {
    return this._http.put<Response>(this._url, model, httpOption);
  }

  delete(model: MovimientoCaja): Observable<Response> {
    return this._http.request<Response>('delete', this._url, {
      body: model,
    });
  }

  readOne(codigo: string): Observable<Response> {
    let url: string = this._url + codigo;
    return this._http.get<Response>(url);
  }
}
